var map = {
	"./0103_IFOK_WIM_MARKER_blue_Publikation_je.svg": "3686",
	"./0103_IFOK_WIM_MARKER_blue_Video_je.svg": "17ad",
	"./0103_IFOK_WIM_MARKER_blue_group_je.svg": "6826",
	"./0103_IFOK_WIM_MARKER_blue_news_je.svg": "165c",
	"./0103_IFOK_WIM_MARKER_blue_topic_je.svg": "ee74",
	"./0103_IFOK_WIM_MARKER_blue_usecase_je.svg": "86af",
	"./0103_IFOK_WIM_MARKER_yellow_group_je.svg": "8998",
	"./0103_IFOK_WIM_MARKER_yellow_news_je.svg": "1568",
	"./0103_IFOK_WIM_MARKER_yellow_publikation_je.svg": "1162",
	"./0103_IFOK_WIM_MARKER_yellow_topic_je.svg": "7aef",
	"./0103_IFOK_WIM_MARKER_yellow_usecase_je.svg": "4c2e",
	"./0103_IFOK_WIM_MARKER_yellow_video_je.svg": "c7af",
	"./0107_IFOK_WIM_MAIN_More_info_button_for_svg_je Kopie-01.svg": "48cd",
	"./MARK_-_AI.svg": "5605",
	"./MARK_-_Digital_Infrastructure.svg": "c70e",
	"./MARK_-_Enviroment.svg": "3a20",
	"./MARK_-_Good_Work.svg": "291b",
	"./MARK_-_Regulation.svg": "5eb4",
	"./MARK_-_Security.svg": "a1c5",
	"./MARK_-_Social.svg": "4f61",
	"./MARK_-_Standards.svg": "6889",
	"./MARK_-_Technology.svg": "0373",
	"./ai.svg": "b917",
	"./digital-infrastructure.svg": "8a92",
	"./environment.svg": "d2ff",
	"./good-work.svg": "61e6",
	"./groups.svg": "0c2f",
	"./news.svg": "da1a",
	"./publication.svg": "dfb9",
	"./regulation.svg": "cdd0",
	"./security.svg": "ecc8",
	"./social.svg": "cce6",
	"./standards.svg": "32fd",
	"./technology.svg": "9ec9",
	"./theme.svg": "4bf7",
	"./use_case.svg": "308c",
	"./video.svg": "1132"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5663";